export default __webpack_public_path__ + "static/media/k.4de1cee8.jpg";